import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class SalesSwitch extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.isSelectAllCheckboxes = $('.is-select-all-checkbox');
    this.isSelectCheckboxes = $('.is-select-checkbox');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    this.isSelectAllCheckboxes.on('change', (event) => {
      return this.refreshCheckboxes(event);
    });
    this.isSelectCheckboxes.on('change', (event) => {
      return this.refreshCheckboxes(event);
    });

    this.App.Events.subscribe('sales.list.set', (data) => {
      return this.onSet(data);
    });

  }

  refreshCheckboxes(event) {

    let checkbox = $(event.currentTarget || null),
        state = checkbox.is(':checked');

    if (checkbox.hasClass('is-select-all-checkbox')) {
      this.isSelectAllCheckboxes.prop('checked', state);
      this.isSelectCheckboxes.prop('checked', state);
    }

    this.isSelectCheckboxes.filter(':checked').closest('tr').addClass('is-selected');
    this.isSelectCheckboxes.filter(':not(:checked)').closest('tr').removeClass('is-selected');

    if (this.isSelectCheckboxes.filter(':checked').length === this.isSelectCheckboxes.length) {
      this.isSelectAllCheckboxes.prop('checked', true);
    } else {
      this.isSelectAllCheckboxes.prop('checked', false);
    }

    this.fireEvent();

  }

  fireEvent() {
    let id = this.isSelectCheckboxes.filter(':checked').map(function() {
      return $(this).val();
    }).get();

    this.App.Events.publish('sales.list.updated', id);
  }

  onSet(response) {

    $.each(response.data, function(index, item){
      $('tr[data-id="'+ item.id +'"] td.has-price').html(item.price);
    });

    setTimeout(() => {

      this.isSelectAllCheckboxes.prop('checked', false).change();
      this.refreshCheckboxes();

    }, 3000);

  }

}